import type { Profile } from "@/modules/profile/api/types"

import { useQuery } from "@tanstack/react-query"

import {
  DEFAULT_QUERY_CACHE_TIME as QUERY_CACHE_TIME,
  DEFAULT_QUERY_STALE_TIME as QUERY_STALE_TIME,
} from "@/modules/api/constants"
import { useLocale } from "@/modules/locales/useLocale"
import { PROFILE_QUERY_KEY } from "@/modules/profile/api/constants"
import { getProfile } from "@/modules/profile/api/getProfile"
import { useCurrentUserFetch } from "@/modules/user/client/hooks/useCurrentUserFetch"

export type UseProfileFetch = {
  dataProfile?: Profile
  isErrorProfile: boolean
  isLoadingProfile: boolean
  isSuccessProfile: boolean
}

export const useProfileFetch = (): UseProfileFetch => {
  const locale = useLocale()
  const { dataCurrentUser } = useCurrentUserFetch()
  const {
    data: dataProfile,
    isError: isErrorProfile,
    isPending: isLoadingProfile,
    isSuccess: isSuccessProfile,
  } = useQuery({
    enabled: !!dataCurrentUser?.isLogged,
    gcTime: QUERY_CACHE_TIME,
    queryFn: () => getProfile({ hostname: typeof window !== "undefined" ? window.location.hostname : "", locale }),
    queryKey: [PROFILE_QUERY_KEY, !!dataCurrentUser?.isLogged, locale],
    staleTime: QUERY_STALE_TIME,
  })

  return {
    dataProfile,
    isErrorProfile,
    isLoadingProfile,
    isSuccessProfile,
  }
}
